import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import type { InternalCalibrationArea } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { CalibrationAreaForm } from './CalibrationAreaForm'
import { useCalibrationAreaForm } from './useCalibrationAreaForm'

type Props = {
  open: boolean
  onClose: () => void
  labelImageUrl: string
  calibrationArea?: InternalCalibrationArea
  saveCalibrationArea: (ca: InternalCalibrationArea) => void
}

export const CalibrationAreaDialog: FC<Props> = ({
  open,
  onClose,
  labelImageUrl,
  calibrationArea,
  saveCalibrationArea,
}) => {
  const { formValues, setValue, canSubmit, handleSave } =
    useCalibrationAreaForm({ calibrationArea, saveCalibrationArea, onClose })

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          height: '80vh',
          maxHeight: '800px',
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          py: 2,
          px: 3,
          minHeight: 56,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Typography variant="h5" component="div" fontWeight="bold">
          位置補正
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <CalibrationAreaForm
          labelImageUrl={labelImageUrl}
          formValues={formValues}
          setValue={setValue}
          canSubmit={canSubmit}
          onSave={handleSave}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  )
}
